
<template>
    <!-- 刷卡记录表 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="filteForm"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item label="来访人姓名">
            <el-input v-model.trim="filteForm.name" auto-complete="off" maxlength="25" class="width80"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              plain
              @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column prop="name" label="姓名"  align=center></el-table-column>
            <el-table-column prop="idCard" label="身份证号" align=center></el-table-column>
            <el-table-column prop="address" label="户籍地址" min-width="200" align=center show-overflow-tooltip></el-table-column>
            <el-table-column prop="deviceCode" label="设备编号" align=center></el-table-column>
            <el-table-column
              prop="imageBase"
              label="识别照片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-image class="img" style="width: 40px;height:40px;" :preview-src-list="[scope.row.imageBase]" :src="scope.row.imageBase"/>
              </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="刷卡时间" align=center></el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        pageNum: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber:0,
        loading:true,
        community:"",
        groupId:"",
        dayStr:"",
        filteForm: {
          type: "",
          name:""
        },
        tableData:[],
        typeList:[],
      };
    },
    methods: {
      //点击查询
      onSubmit() {
        this.pageNum = 1;
        this.getTableData();
      },
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
      //获取分页的紧急按钮数据  只获取pageSize条数据
      getTableData() {
        let params = {
          groupId:this.groupId,
          pageSize:this.pageSize,
          pageNum:this.pageNum,
          community:this.community||"",
          name:this.filteForm.name
        };
        this.loading = true;
        //人脸识别认证机
        this.$postJson('dmc/record/queryRecordWithPage',params).then(res=>{
          if(res.code==200){
            this.totalDataNumber = Number(res.result.total)
            res.result.list.forEach(item=>{
              if(item.picture !=null){
                item.imageBase = item.picture;
              }else{
                item.imageBase = "data:image/png;base64,"+item.imageBase;
              }
            })
            this.tableData = res.result.list;
          }
          this.loading = false;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
      
    },
    mounted() {
      this.getTableData();
    },
    created(){
      this.groupId = sessionStorage.getItem("groupId");
      // let street = window.sessionStorage.getItem("street");
      this.community = window.sessionStorage.getItem("community");
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  </style>